import React, { useEffect, useState } from "react"
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

// assets
import IconThin from './icon-thin-women'
import IconFat from './icon-fat-women'
import { convertPersianDigits } from "../utils/convertDigits"

const Weight = (props) => {
	const [value, setValue] = useState()
	const [value2, setValue2] = useState()

	useEffect(() => {
		setValue(props.value)
	}, [props.value])

	const ChangeRangeValue = value => {
		setValue(value)
		setValue2(value)
	};

	const handleChangeComplete = () => {
		props.change(value)
	};

	const handleChangeInput = (e) => {
		let converted= convertPersianDigits(e.target.value)
		let val = Number(converted)
		setValue2(val)
		setValue(val)
		props.change(val)
	}

	const scroll = async () => {
		setTimeout(() => {
			const section = document.getElementById('weight_field');
			section.scrollIntoView({ behavior: 'smooth', block: 'start', });
		}, 200);
	}

	return <>
		<div id="weight_field"></div>
		<div className="weight_field">
			<div className="display_flex justify_content_center align_items_center title">
				<label>الوزن&nbsp;</label>
				<small>(كيلوغرام)</small>
			</div>
			<div className="display_flex justify_content_center align_items_center">
				<div className="value_wrapper" dir='ltr'>
					<input
						className="value" type="number" value={value2 || ''}
						min={40}
						max={200}
						onFocus={() => scroll()}
						onChange={(e) => handleChangeInput(e)}
						placeholder={75}
					/>
				</div>
			</div>

			<div className='slider' dir="ltr">
				<span className="icon_left"><IconThin /></span>
				<span className="icon_right"><IconFat /></span>
				<Slider
					min={40}
					max={200}
					value={value}
					onChange={ChangeRangeValue}
					onChangeComplete={handleChangeComplete}
				/>
			</div>

		</div>
	</>
}
export default Weight